import React from "react";
import { Routes, Route } from 'react-router-dom';
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import WritingPage from "./pages/WritingPage";
import ProjectPage from "./pages/ProjectPage";

function App() {
  return (
    <>
    <Navbar /> 
      <Routes>
        <Route exact path="/project" element={<ProjectPage />} />
        <Route exact path="/about" element={<AboutPage />} />
        <Route exact path="/writing" element={<WritingPage />} />
        <Route exact path="/" element={<HomePage />} />
      </Routes>
      <Footer />
      </>
   );

}

export default App;
